<template>
  <b-container>
    <h1>{{ $t("system.module.profile") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <div class="form-group" v-for="row in model" :key="row.profilesId">
      <b-row>
        <b-col md="4">
          <label class="pt-2">{{ row.profileName }}</label>
        </b-col>
        <b-col md="4">
          <b-form-select :options="hasAccess" v-model="row.active">
          </b-form-select>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col>
        <b-button type="submit" :disabled="submitted" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- <div>{{ id }}</div> -->
  </b-container>
</template>
<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      model: [],
      hasAccess: [
        { value: true, text: "Possui acesso" },
        { value: false, text: "Não possui acesso" },
      ],
      submitted: false,
    };
  },
  created() {
    this.loadProfiles();
  },
  computed: {
    getUrlBackToList() {
      return `../../module/all`;
    },
  },
  methods: {
    loadProfiles() {
      console.log(this.id);
      this.$apiScheduler
        .get("/moduleProfile/getAll/" + this.id)
        .then((response) => {
          console.log(response);
          const items = response.data;
          this.model = items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    save() {
      this.submitted = true;

      this.$apiScheduler
        .post("/moduleProfile/save/", this.model)
        .then((response) => {
          console.log(response);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
            this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
